import { render, staticRenderFns } from "./FormCheckbox.vue?vue&type=template&id=f6bbbeba&scoped=true"
import script from "./FormCheckbox.vue?vue&type=script&lang=js"
export * from "./FormCheckbox.vue?vue&type=script&lang=js"
import style0 from "./FormCheckbox.vue?vue&type=style&index=0&id=f6bbbeba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bbbeba",
  null
  
)

export default component.exports